var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1800 1800"}},[_c('path',{attrs:{"d":"M881 80a828 828 0 10827 828c0-457-370-828-827-828zm362 932H518V856h725v156z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }